{
  "uploadLogo": "upload logo",
  "Link": "Link",
  "UploadTips": "We recommend at minimum, images be 1056 x 192 pixels. For best results, upload images that are 2560 x 192 pixels. 2560 width is optimal for displaying across desktop, laptop, and mobile",
  "selectLogo": "select logo",
  "selectImage": "select image",
  "errorMessage": "There was an error validating some of your emails. Please only use commas, semicolons, and spaces to separate the email addresses.",
  "emailAlreadyAddedError": " has already been added.",
  "emailNotValidError": " is not a valid email address.",
  "ImageNotSupported": "Image format not supported.",
  "SupportedFormats": "Image format not supported. Supported formats are jpg, jpeg, png, gif and jfif.",
  "ImageFailedToUpload": "Image failed to upload. Try again later.",
  "firstName": "First Name",
  "lastName": "Last Name",
  "Purpose": "Purpose",
  "add": "add",
  "AddAlternativeEmail": "Add an alternative email",
  "AvatarUploadHeadingPart1": "Select your",
  "Photo": "Photo",
  "select": "select",
  "PhotoLimit": "Great photo but it exceeded the max size: 10mb.",
  "SkipForNow": "skip for now",
  "SponsorNameRequired": "Sponsor name is required",
  "URLvalidation": "Enter a Valid URL",
  "fileRequired": "A file is required",
  "InputLabel1": "Name of Sponsor Company",
  "InputLabel1Placeholder": "Name Of The Sponsor Company (required)",
  "InputLabel2": "Website",
  "delete": "Delete",
  "UpdateSponsor": "Update Sponsor",
  "AddSponsor": "Add Sponsor",
  "SponsorAdded": "Sponsor added successfully.",
  "SelectLogo": "Select logo",
  "AddSponsorButton": "Add sponsor",
  "SponsorUpdated": "Sponsor updated successfully.",
  "SponsorDeleted": "Sponsor deleted successfully.",
  "photoLimit": "Great photo but it exceeded the max size: 5mb.",
  "ValidateAwardType": "Select Award Type",
  "ValidateProject": "Select A Project",
  "ConfirmAwards": "Confirm Awards",
  "ConfirmAwardsMessage": "Are you sure? You will not be able to change this later.",
  "goBackButton": "No, go back",
  "YesSubmitButton": "Yes, submit",
  "AwardOption1": "Just One",
  "AwardOption2": "Winner And Runner Up",
  "AwardOption3": "Top 3",
  "title": "How many winners?",
  "SelectHowMany": "Select how many",
  "SelectProject": "Select Project",
  "SubmitButton": "Submit",
  "duplicateProjectWarning": "No duplicate project selection allowed.",
  "ChangeTeamRoleStep1": "Make",
  "ChangeTeamRoleStep2": "Select Role",
  "SaveButton": "Save ",
  "save+next": "save + next",
  "EditEventConfirm": "Confirm to submit",
  "EditEventConfirmMessage": "Are you sure to do this?",
  "Yes": "Yes",
  "No": "No",
  "EventNameRequired": "Event name is required",
  "EventTypeRequired": "Event type is required",
  "EditEventTitle": "Edit Your Event",
  "EventName": "Name Of The Event",
  "to": "to",
  "Online": "Online",
  "ClickHere": "Online Only? Click here",
  "EventType": "Select an Event Type",
  "EventDescriptionPlaceholder": "Event Description (max 250 characters)",
  "UpdateEventButton": "Update Event",
  "AddEventButton": "Add Event",
  "EventEndingError": "Oh no. Your event seems to be ending before it has started.",
  "EventUpdatedMessage": "Event Updated.",
  "cancel": "cancel",
  "updatedSuccessfully": "updated successfully.",
  "addedSuccessfully": "added successfully.",
  "HubSettings": "Hub Settings",
  "saveButtonPart2": " to project page",
  "SaveImageButton": "Save {{imageType}} to project page",
  "RoleTypeRequired": "Role Type is required",
  "InviteParticipantsTitle": "Invite Participants",
  "InviteParticipantsPart1": "Invite people to participate and contribute to your event.",
  "InviteParticipantsPart2": "Select a role",
  "InviteParticipantsPart3": "Select role(s):",
  "InviteParticipantsPhrase1": "Rebel",
  "InviteParticipantsPhrase1Part2": "working on innovation",
  "InviteParticipantsPhrase2": "Supporter",
  "InviteParticipantsPhrase2Part2": "lending expertise",
  "or": "or",
  "InviteParticipantsPhrase3": "General",
  "InviteParticipantsPhrase3Part2": "no role",
  "EnterEmailAddress": "Type an email address and press 'Enter'",
  "EnterEmailAddressPlaceholder": "Add multiple email addresses one at a time",
  "PersonalizeInvitation": "Personalize your invitation with a message",
  "AddMessage": "Add a personal message that will be delivered along with your event invitation...",
  "optional": "optional",
  "Finish": "Finish",
  "back": "back",
  "SelectRoleType": "select role",
  "Invitations": "Invitations",
  "Send": "Send",
  "IncorrectEmailErrorMessage": "Oh no. You seems to type an incorrect email.",
  "TitleRequired": "Title is required",
  "JudgeBioTitle": "Edit Your Bio",
  "TitlePlaceholder": "title",
  "BioPlaceholder": "tell us about your beautiful self",
  "updateButton": "update",
  "addButton": "add",
  "BioUpdated": "Bio updated successfully.",
  "BioAdded": "Bio added successfully.",
  "Bio": "Bio",
  "ManageParticipantTitle": "Invite to",
  "PendingInvites": "Pending Invites",
  "sendANudge": "Nudge",
  "NoPendingInvitations": "No pending invitations",
  "Participants": "Participants",
  "changeRole": "change role",
  "notePlaceholder": "Tell them what you think",
  "note": "note",
  "Please": "Please",
  "login": "log in",
  "signup": "sign up",
  "addNote": "to add a note.",
  "permissionFormTitle": "Who can see this?",
  "permission1": "Team Only",
  "permission2": "My Events",
  "permission3": "My Hubs, Groups, Events",
  "permission4": "Everyone",
  "CloseAbout": "Close About",
  "CloseWarningMessage": "Are you sure you want to close?",
  "YesCloseButton": "Yes, close",
  "closeButton": "close",
  "ProjectProfileFormPhrase1": "This is your playground.",
  "ProjectProfileFormPhrase2": "Seize the attention of your audience with your story: who you are, what you strive to do, and why we should care.... Trust me, we want to know.",
  "ProjectProfileFormPhrase3": "Invite people to dive into a visually immersive experience - use engaging videos and creative images to paint a picture with more than just your words. Ventures that tell their tales through visuals are more likely to succeed.",
  "ImageSizeErrorMessage": "Image Size should not be more than 3MB",
  "ProjectSettingsTitle": "Project Settings",
  "ProjectName": "Project Name",
  "Industry": "Industry",
  "HideFromSearch": "Hide from search ?",
  "ResourceLabelRequired": "Resource Label is required",
  "ResourceLabelUpdated": "Resource Label Updated Successfully.",
  "TemplateTitle": "Name custom template:",
  "TemplatePlaceholder": "template name",
  "OverwriteTemplate": "Or choose template to overwrite:",
  "SelectTemplate": "Select Template",
  "NoCustomTemplate": "No custom template to overwite",
  "TemplateName": "Enter template name or select one from the list.",
  "TemplateNameCharLimit": "Template name should not exceed 50 characters",
  "TemplateNameTaken": "Template name is already taken.",
  "TemplatesSaved": "Templates saved successfully",
  "NoProjectYet": "You don't have any projects yet.",
  "CreateProject": "Create a project",
  "SelectProjectLater": "select project later",
  "SubmitProject": "submit my project",
  "SelectProjectTitle": "SELECT PROJECT FOR",
  "CurrentlySubmitted": "Currently Submitted:",
  "SelectProjectFormPhrase1": "All",
  "SelectProjectFormPhrase1Part2": "team members will get an invite",
  "SelectProjectFormPhrase2": "You have no other project to change to.",
  "ok": "ok",
  "ProjectAdded": "Project added successfully.",
  "SelectProjectCaps": "SELECT PROJECT",
  "StartRoundFormTitle": "Projects being scored in",
  "NoProjectsWarning": "There must be at least one submitted project before a round can be opened. Invite competitors to the event.",
  "NoJudgesWarning": "There must be at least one judge before a round can be opened. Invite judges to the event.",
  "StartRoundFormPhrase1": "select at least one below",
  "StartRoundFormPharse2": "Judges in",
  "Round": "Round",
  "OpenRoundButton": "open this round!",
  "RoundOpened": "Round Opened.",
  "SupportsUpdated": "Supports updated.",
  "SelectAtleast1Judge": "Select at least one Judge",
  "SelectAtleast1Project": "Select at least one Project",
  "LoadingYourContent": "Loading your content...",
  "ImageSizeLimit": "Great photo but it exceeded the max size: 5mb.",
  "ImageSizeLimit3mb": "Great photo but it exceeded the max size: 3mb.",
  "SelectFeild": "Select a",
  "Type": "Type",
  "email": "email",
  "phoneNumber": "phone number",
  "countryRegion": "country/region",
  "companyName": "company name",
  "jobTitle": "job title",
  "datesAndTimes": "a couple of dates and times that works best for you",
  "Submitting": "Submitting...",
  "EmailError1": "Enter valid email",
  "EmailError2": "Email is required",
  "EnterValidPhoneNum": "Please enter a valid phone number",
  "MaxLimitError": "Max limit for message is 250 characters",
  "questionAnswer": "Question",
  "idea": "Idea",
  "announcement": "Announcement",
  "post": "Post",
  "offer": "Offer",
  "SuccesfullySent": "Your invites have been sent!",
  "Invite People": "Invite People",
  "Add Email(s)": "Add Email(s)",
  "inviteSentMsg": "Your invites have been sent!",
  "errorSendingInviteMsg": "There were issues with some of the emails you provided, for more details",
  "errorSendingInvites": "Error Sending Invites",
  "Email": "Email",
  "already member": "Already a member",
  "already invited": "Already Invited",
  "invalid email": "Invalid email",
  "invalidEmail": "Please enter a valid email address",
  "AddLocation": "Add a location",
  "NoLocations": "No locations",
  "LocationSearchUnavailable": "Location search is unavailable right now. Please try again.",
  "UnsavedChangesTitle": "Leave without saving?",
  "UnsavedChangesWarning": "You have unsaved changes on this page. If you leave now they will be lost.",
  "leave": "Leave",
  "stay": "Stay"
}
